import "./RegulatedAndSpecialistIndustries.module.css";
import Header from "@/reusable_sections/Header";
import IndustryHub from "./sections/IndustryHub";
import RegulatedStrategy from "./sections/RegulatedStrategy";
import RelatedServicesCta from "./sections/RelatedServicesCta";
import Footer from "@/reusable_sections/Footer";
export default function RegulatedAndSpecialistIndustriesPage() {
  return <div>
      <Header />
      <IndustryHub />
      <RegulatedStrategy />
      <RelatedServicesCta />
      <Footer />
    </div>;
}